(function () {
  'use strict';

  if (!/\/(?:pages\/)?join\/?$/.test(window.location.pathname) || window.__zenifiedTikTokJoin) return;
  window.__zenifiedTikTokJoin = true;

  var pixelId = 'D88AE33C77UE4JC9AHL0';
  var formIds = ['6ad38809e171c7a9af2d0ec0', '6ad39b86e171c7a9af2d0f5d'];
  var viewSent = false;
  var registrationStarted = false;
  var privacyLoading = false;
  var consentActive = false;

  function permitted() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return Boolean(privacy && privacy.analyticsProcessingAllowed() &&
        privacy.marketingAllowed() && privacy.saleOfDataAllowed());
    } catch (_) {
      return false;
    }
  }

  function pixel() {
    if (!permitted()) return null;
    var ttq = window.ttq;
    if (!ttq) {
      window.TiktokAnalyticsObject = 'ttq';
      ttq = window.ttq = [];
      ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
      ttq.setAndDefer = function (target, method) {
        target[method] = function () { target.push([method].concat(Array.prototype.slice.call(arguments))); };
      };
      ttq.methods.forEach(function (method) { ttq.setAndDefer(ttq, method); });
      ttq.instance = function (id) {
        var instance = ttq._i[id] || [];
        ttq.methods.forEach(function (method) { ttq.setAndDefer(instance, method); });
        return instance;
      };
      ttq.load = function (id, options) {
        var url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {};
        ttq._i[id] = [];
        ttq._i[id]._u = url;
        ttq._t = ttq._t || {};
        ttq._t[id] = Date.now();
        ttq._o = ttq._o || {};
        ttq._o[id] = options || {};
        var script = document.createElement('script');
        script.async = true;
        script.src = url + '?sdkid=' + encodeURIComponent(id) + '&lib=ttq';
        document.head.appendChild(script);
      };
      ttq.holdConsent();
    }
    if (typeof ttq.load !== 'function' || typeof ttq.instance !== 'function') return null;
    if (!ttq._i || !ttq._i[pixelId]) ttq.load(pixelId);
    if (!consentActive && typeof ttq.grantConsent === 'function') ttq.grantConsent();
    consentActive = true;
    return ttq.instance(pixelId);
  }

  function syncConsent() {
    if (!permitted()) {
      if (consentActive && window.ttq && typeof window.ttq.revokeConsent === 'function') window.ttq.revokeConsent();
      consentActive = false;
      return;
    }
    var target = pixel();
    if (target && !viewSent) {
      target.track('ViewContent', { description: 'Zenified Circle early access page' });
      viewSent = true;
    }
  }

  function connectPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) return syncConsent();
    if (privacyLoading || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    privacyLoading = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      privacyLoading = false;
      if (!error) syncConsent();
    });
  }

  async function onFormEvent(event) {
    var detail = event.detail || {};
    if ((detail.type || detail.eventName) !== 'submit' || !detail.form ||
        formIds.indexOf(detail.form.id) === -1 || registrationStarted || !permitted()) return;
    registrationStarted = true;
    var email = detail.formValues && detail.formValues.emailField;
    var emailHash;
    if (typeof email === 'string' && email.trim() && window.crypto && window.crypto.subtle) {
      try {
        var digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(email.trim().toLowerCase()));
        emailHash = Array.from(new Uint8Array(digest), function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
      } catch (_) {}
    }
    email = null;
    if (!permitted()) return;
    var target = pixel();
    if (!target) return;
    if (emailHash) target.identify({ email: emailHash });
    target.track('CompleteRegistration', { description: 'Zenified Circle early access signup' });
  }

  window.addEventListener('omnisendForms', onFormEvent);
  document.addEventListener('visitorConsentCollected', syncConsent);
  window.addEventListener('load', connectPrivacy, { once: true });
  connectPrivacy();
}());
